import { useTokenSales } from '@entities/trades/token-sell';
import type { ITokenSaleTableColumns } from '@entities/trades/token-sell';
import { useRefetchAuto } from '@features/refetch-auto';
import ErrorMessage from '@shared/components/ErrorMessage';
import Loading from '@shared/components/Loading';
import LoadingSpinner from '@shared/components/LoadingSpinner';
import { Pagination, PaginationRows } from '@shared/components/Pagination';
import { Table, THead, TBody, TableContainer, TableProvider } from '@shared/components/Table';

import { useTableSettings } from './settings/useTableSettings';

const TokenSalesWidget = () => {
  const { refreshInterval, setRefreshInterval } = useRefetchAuto({
    storageKey: 'refetch-auto-token-sales',
  });

  const {
    tokenSales,
    isLoading,
    isError,
    error,
    isFetching,
    refetch,

    filter,
  } = useTokenSales({ refreshInterval });

  const { columnTitles, renderRow, renderFilterElement, getTheadAfter, getTbodyAfter } =
    useTableSettings({
      refetch,
      refreshInterval,
      setRefreshInterval,
    });

  if (isLoading) return <LoadingSpinner />;
  if (isError) return <ErrorMessage error={error} />;

  if (tokenSales) {
    return (
      <>
        {isFetching && <Loading />}

        <TableProvider<ITokenSaleTableColumns>
          columnTitles={columnTitles}
          storageKey='token-sales'
          {...filter}
        >
          <TableContainer>
            <Table>
              <THead
                items={tokenSales.data}
                renderItem={renderFilterElement}
                afterColumns={getTheadAfter}
              />
              <TBody
                items={tokenSales.data}
                renderItem={renderRow}
                afterColumns={getTbodyAfter}
              />
            </Table>
          </TableContainer>
          <div className='pagination-container'>
            <Pagination data={tokenSales.meta} />
            <PaginationRows />
          </div>
        </TableProvider>
      </>
    );
  }

  return null;
};

export default TokenSalesWidget;
